import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VALIDATION_RULES } from "@/constants/ValidationRules";
import { INPUT_TYPES } from "@/constants/InputTypes";
import SimpleCrud from "@/components/SimpleCrud.vue";
import moment from "moment";
import _ from "lodash";
import Snackbar from "@/components/Snackbar.vue";
import { IN_PERSON_METHODS, PAYMENT_METHODS } from "@/constants/PaymentMethods";
import { collectPayment } from "@/utils/payments";
let Vouchers = class Vouchers extends Vue {
    title = 'Poukazy';
    storeModule = 'voucher';
    formAddTitle = 'Nový poukaz';
    formEditTitle = 'Upravit poukaz';
    headers = [
        {
            text: 'Kód',
            value: 'data.code',
            rules: [],
            type: INPUT_TYPES.TEXT,
            notEditable: true,
        },
        {
            text: 'Převzal',
            value: 'data.owner',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.TEXT,
            readOnly: true,
        },
        {
            text: 'Cena',
            value: 'data.price',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.UNSIGNED_NUMBER],
            type: INPUT_TYPES.NUMBER,
            readOnly: true,
        },
        {
            text: 'Hodnota',
            value: 'data.value',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.POSITIVE_NUMBER],
            type: INPUT_TYPES.NUMBER,
            readOnly: true,
        },
        {
            text: 'Zbývající hodnota',
            value: 'data.remainingValue',
            rules: [],
            type: INPUT_TYPES.NUMBER,
            notEditable: true,
        },
        {
            text: 'Platnost do',
            value: 'data.validTo',
            rules: [VALIDATION_RULES.DATE_AFTER],
            type: INPUT_TYPES.DATE,
        },
        {
            text: '',
            value: 'actions',
            rules: [],
            type: '',
            sortable: false,
            notEditable: true,
        },
    ];
    defaultItem = {
        id: 'new-voucher',
        data: {
            code: '',
            owner: '',
            value: 500,
            remainingValue: 500,
            price: 500,
            validTo: moment().add(1, 'year').year() + '-05-31',
            active: true,
            deletedAt: null,
        },
    };
    saleDialog = false;
    saleVoucher = null;
    saleMethod = '';
    selling = false;
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get paymentMethods() {
        return PAYMENT_METHODS.filter(method => IN_PERSON_METHODS.includes(method.id));
    }
    /** A sale can be interrupted, so an unpaid voucher stays sellable from the list. */
    isUnpaid(voucher) {
        return voucher.data.price > 0 && !voucher.data.payment;
    }
    openSale(voucher) {
        if (voucher.data.price <= 0) {
            return;
        }
        this.saleVoucher = _.cloneDeep(voucher);
        this.saleMethod = '';
        this.saleDialog = true;
    }
    async sell() {
        if (this.selling || this.saleVoucher === null)
            return;
        this.selling = true;
        try {
            const result = await collectPayment('payVoucher', { voucherId: this.saleVoucher.id }, this.saleMethod);
            if (result) {
                Snackbar.success(`Doklad ${result.number} vystaven.`);
                if (result.warning) {
                    Snackbar.info(result.warning);
                }
                this.saleDialog = false;
            }
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e instanceof Error ? e.message : 'Platbu se nepodařilo zpracovat');
        }
        finally {
            this.selling = false;
        }
    }
};
Vouchers = __decorate([
    Component({
        components: { SimpleCrud },
    })
], Vouchers);
export default Vouchers;
